<template>
  <div class="limited-offer container">
    <div class="limited-offer-container" :class="campaignPage ? className : 'col-6'">
      <client-only>
        <p v-if="!options.course && !options.preTitleSlot" class="subtitle">
          {{ options.pretitle || 'Limited-Time Offer' }}
        </p>
        <div v-else-if="options.preTitleSlot" class="subtitle">
          <slot name="pre-title" />
        </div>
        <h2 v-if="options.htmltitle" class="h2 heading" v-html="options.htmltitle" />
        <h2 v-else class="h2 heading">
          {{ options.title }}
          <IconLeagueBlur class="icon-league-blur" :class="{ show: icons }" />
        </h2>
        <div v-if="!options.course" class="switch-holder">
          <span
            :class="{ 'unactive': promoPlan }"
          >
            {{ options.comparisonPlanBilledText }}
          </span>
          <label class="switch">
            <input v-model="promoPlan" type="checkbox">
            <span class="slider" />
          </label>
          <span
            :class="{ 'unactive': !promoPlan }"
          >
            {{ options.promoPlanBilledText }}
          </span>
        </div>
        <div v-if="promoPlan" class="price">
          <div v-show="options.regularPrice > options.discountedPrice" class="regular-price">
            {{ options.regularPrice }}
          </div>
          <div class="discounted-price h2">
            <span v-if="options.htmlDiscountedPrice" v-html="options.htmlDiscountedPrice" />
            <span v-else class="promo-price" :title="options.discountedPrice.includes('.') ? options.discountedPrice : `${options.discountedPrice}.00`">{{ options.discountedPrice.includes('.') ? options.discountedPrice : `${options.discountedPrice}.00` }}</span>
            <span class="body-1"> {{ options.discountedPriceCharge }} </span>
          </div>
        </div>
        <div v-else class="price" :class="{ comparison: options.comparisonPriceSubtitle !== '' }">
          <div v-if="options.comparisonRegularPrice" class="regular-price">
            {{ options.comparisonRegularPrice }}
          </div>
          <div class="discounted-price h2">
            {{ options.billedComparisonPrice.includes('.') ? options.billedComparisonPrice : `${options.billedComparisonPrice}.00` }}
            <span class="body-1"> {{ options.billedComparisonCharge }} </span>
          </div>
          <div v-if="options.comparisonPriceSubtitle" class="price-subtitle">
            {{ options.comparisonPriceSubtitle }}
          </div>
        </div>
        <slot v-if="promoPlan" name="text-decoration" />
        <hr>
        <ul
          v-if="$store.state.layout === 'mobile' && !$store.state.tablet"
          class="plan-features"
          :style="{ 'margin-top': (!promoPlan && icons) ? '48px' : '0' }"
        >
          <img class="icon-r" :class="{ show: icons }" src="../../assets/images/icon-r.png">
          <img class="icon-chart-blur" :class="{ show: icons }" src="../../assets/images/icon-chart-blur.png">
          <li
            v-for="(feature, i) in featuresMobile"
            :key="i"
            class="feature body-2"
          >
            <IconCheck />
            {{ feature.name }}
          </li>
        </ul>
        <ul
          v-else
          class="plan-features"
          :style="{ 'margin-top': (!promoPlan && icons) ? '48px' : '0' }"
        >
          <img class="icon-r" :class="{ show: icons }" src="../../assets/images/icon-r.png">
          <img class="icon-chart-blur" :class="{ show: icons }" src="../../assets/images/icon-chart-blur.png">
          <li
            v-for="(feature, i) in features"
            :key="i"
            class="feature body-2"
          >
            <IconCheck />
            {{ feature.name }}
          </li>
        </ul>
        <div v-if="options.campaign === 'one-of-two-hundred'" class="button-holder">
          <span class="btn-shadow" />
          <span class="btn-lg btn-3d" @click="$emit('subscribe', promoPlan ? options.promoPlanType : options.comparisonPlanType)">
            {{ promoPlan ? options.promoPlanButtonText : options.comparisonPlanButtonText }}
          </span>
        </div>
        <button
          v-else
          class="btn-primary" :class="[options.buttonClass, promoPlan ? options.promoPlanSubscribeClass : options.comparisonSubscribeClass, { 'btn-lg': !campaignPage }]"
          @click="$emit('subscribe', promoPlan ? options.promoPlanType : options.comparisonPlanType)"
        >
          {{ promoPlan ? options.promoPlanButtonText : options.comparisonPlanButtonText }}
        </button>
        <Badges
          v-if="options.badges !== undefined ? options.badges : true"
          :dark="options.badgesDark || !options.badgesLight" :light="options.badgesLight"
          class="badges pricing"
        />
        <span class="vat-note">{{ options.vat || 'VAT may be applied' }}</span>
      </client-only>
    </div>
  </div>
</template>

<script>
import Badges from '@itbpbg/lms-components/src/Pricing/Badges';
import IconLeagueBlur from '../../assets/svg/icon-league-blur.svg?vue-component';
import IconCheck from '../../assets/svg/icon-list-check.svg?vue-component';

export default {
  components: {
    IconLeagueBlur,
    Badges,
    IconCheck,
  },
  props: {
    preTitleSlot: Boolean,
    options: { type: Object, default: () => {}, required: true },
    features: { type: Array, default: () => [], required: true },
    saveLabel: { type: String, default: '', required: false },
    icons: { type: Boolean, required: false },
    reorderFeatures: { type: Boolean, required: false },
    campaignPage: { type: Boolean, required: false },
    className: { type: String, default: '', required: false },
  },
  data() {
    return {
      promoPlan: true,
    };
  },
  computed: {
    // scrambled features for mobile
    featuresMobile() {
      if (this.reorderFeatures) {
        const odds = this.features.filter((el, i) => i % 2 !== 0);
        const evens = this.features.filter((el, i) => i % 2 === 0);
        return evens.concat(odds);
      }
      return this.features;
    },
  },
};
</script>

<style lang="scss">
.limited-offer {
  .limited-offer-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .subtitle {
    font-size: 18px;
    color: var(--main-light-shade-4);
  }

  .h2 {
    text-align: center;
    margin-bottom: var(--spacing-28);

    .heading {
      text-transform: capitalize;
    }

    .icon-league-blur {
      display: none;
      position: absolute;
      right: 170px;
      top: -50px;
      z-index: -1;

      &.show {
        display: block;
      }
    }
  }

  .switch-holder {
    position: relative;
    display: inline-flex;
    align-items: center;

    .switch {
      margin-right: var(--spacing-20);
      margin-left: var(--spacing-20);

      .slider:before {
        width: 18px;
        height: 18px;
        top: 2px;
      }
    }

    span {
      margin-bottom: 0;
      font-size: 16px;
      color: var(--main-light-shade-4);
    }
  }

  .price {
    display: flex;
    margin-top: var(--spacing-60);
    padding: 0 54px 18px;
    align-items: center;
    justify-content: center;

    .regular-price {
      display: inline-block;
      margin-right: var(--spacing-12);
      font-size: 24px;
      color: var(--main-light-shade-4);
      position: relative;

      &:before {
        content: '';
        top: 50%;
        left: 0;
        right: 0;
        position: absolute;
        transform: translateY(-50%);
        height: 2px;
        width: 100%;
        background-color: var(--main-light-shade-4);
      }
    }

    .discounted-price {
      position: relative;
      margin: 0;

      .group {
        position: relative;
        font-weight: 700;
        font-size: 52.0117px;
        line-height: 91.7%;
        color: #25F4EE;

        .subgroup {
          position: absolute;
          font-weight: 700;
          font-size: 52.0117px;
          line-height: 91.7%;
          color: #E31010;
          mix-blend-mode: screen;
          left: -3px;
          top: 6px;

          &:before {
            font-weight: 700;
            font-size: 52.0117px;
            line-height: 91.7%;
            content: attr(title);
            color: #FCFC53;
            mix-blend-mode: lighten;
            position: absolute;
            left: 5px;
            top: -2px;
            width: 100%;
          }

          &:after {
            font-weight: 700;
            font-size: 52.0117px;
            line-height: 91.7%;
            content: attr(title);
            color: #E75CEE;
            mix-blend-mode: screen;
            position: absolute;
            left: 3px;
            top: -4px;
            z-index: 1;
            width: 100%;
          }
        }
      }
    }
  }

  hr {
    width: 100%;
    border: none;
    height: 1px;
    background-color: #6F7379;
    margin-bottom: var(--spacing-36);
  }

  .plan-features {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 30px;
    margin-bottom: var(--spacing-60);
    padding-left: 0;
    list-style: none;

    .icon-r {
      width: 129px;
      height: 110px;
      display: none;
      position: absolute;
      left: 174px;
      top: 150px;
      z-index: -1;

      &.show {
        display: block;
      }
    }

    .icon-chart-blur {
      display: none;
      position: absolute;
      right: 50px;
      top: 440px;
      z-index: -1;

      &.show {
        display: block;
      }
    }

    .feature {
      margin-bottom: var(--spacing-32);
      line-height: 150%;

      svg {
        vertical-align: middle;
        margin-right: var(--spacing-6);

        path[stroke] {
          stroke: var(--accent);
        }
      }

      .icon-check {
        width: 13px;
        margin-right: 10px;
      }
    }
  }

  .btn-primary {
    width: 100%;
    max-width: 350px;
    margin-bottom: var(--spacing-16);
  }

  .vat-note {
    font-size: var(--spacing-14);
  }
}

@include bp($bp-laptop) {
  .limited-offer .btn-primary {
    max-width: 310px;
  }
}

@include bp($bp-mobile) {
  .limited-offer {
    .container {
      .h2 {
        font-size: 32px;
      }
    }
  }
}

@include bp($bp-phone) {
  .limited-offer {
    .subtitle {
      font-size: var(--spacing-16);
    }

    .switch-holder {
      text-align: center;

      > span:not(.unactive) {
        color: var(--main-light);
      }

      .switch {
        margin: 0 10px;
      }
    }

    .price {
      align-items: flex-end;
      padding-left: 0;
      padding-right: 0;

      .regular-price {
        font-size: var(--spacing-18);
      }

      .discounted-price {
        font-size: var(--spacing-36);
      }
    }

    .plan-features {
      column-gap: var(--spacing-12);

      .feature {
        margin-bottom: var(--spacing-14);
        font-size: var(--spacing-14);
      }
    }
  }
}
</style>
